import { actionGenerator, IReduxAction } from '../../../actionGenerator';

export const CHANGE_AUTO_PROLONG = 'CHECKOUT_INFO :: CHANGE_AUTO_PROLONG';

export type TChangeAutoProlongAction = IReduxAction<typeof CHANGE_AUTO_PROLONG, boolean>;

export const changeAutoProlong = actionGenerator<typeof CHANGE_AUTO_PROLONG, boolean>(CHANGE_AUTO_PROLONG);
